import { render, staticRenderFns } from "./PushMessageTemplate.vue?vue&type=template&id=dda889bc&"
import script from "./PushMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./PushMessageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports